import type { ProposalItem } from "modules/trade-proposals/model/tradeProposal";
import type { TradeItem } from "modules/tradeLists/model/tradeList";

export function tradeItemToProposalItem(item: TradeItem): ProposalItem {
  const defaultPrice = item.price?.value?.default ?? 0;
  return {
    ids: item.ids,
    dataId: item.dataId,
    oracleId: item.oracleId,
    name: item.name,
    game: item.game,
    setCode: item.setCode,
    number: item.number,
    finishes: item.finishes?.map(String) ?? [],
    language: String(item.language),
    condition:
      typeof item.condition === "number"
        ? item.condition
        : parseInt(String(item.condition), 10) || 0,
    quantity: parseInt(String(item.quantity), 10) || 1,
    customPrice: defaultPrice,
    rarity: item.rarity,
    price: defaultPrice,
    maxQuantity: parseInt(String(item.quantity), 10) || 1,
    spokenForQuantity: item.spokenForQuantity,
  };
}
